import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["min", "data-fehlermeldung"]
const _hoisted_2 = ["max", "required", "aria-required", "data-fehlermeldung"]
const _hoisted_3 = ["required", "aria-required"]
const _hoisted_4 = ["required", "aria-required"]
const _hoisted_5 = ["min", "max", "required", "aria-required", "data-fehlermeldung"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["required", "aria-required"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["data-fehlermeldung", "max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_Infotext = _resolveComponent("Infotext")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_infotext = _resolveComponent("infotext")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 1,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_ueberschrift, { key: 0 }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("Gebäudedetails")
            ])),
            _: 1,
            __: [37]
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "dachVarianteInfo"
              }, {
                default: _withCtx(() => _cache[38] || (_cache[38] = [
                  _createElementVNode("strong", null, "Dachart- und ausbau", -1)
                ])),
                _: 1,
                __: [38]
              }),
              _createVNode(_component_zelle, { class: "iconRadioDachausbau" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    id: "dachAusgebaut",
                    class: "no-outline",
                    name: "dachvariante",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.dachvariante) = $event)),
                    type: "radio",
                    value: "3",
                    required: "",
                    autofocus: "",
                    tabindex: "0",
                    "aria-required": "true",
                    "aria-label": "ausgebautes Dach",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl.",
                    "data-cy": "LoftConversion"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.dachvariante]
                  ]),
                  _cache[39] || (_cache[39] = _createElementVNode("label", {
                    for: "dachAusgebaut",
                    class: "radiolabelDachausbau"
                  }, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "dachNichtAusgebaut",
                    name: "dachvariante",
                    class: "no-outline",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.dachvariante) = $event)),
                    type: "radio",
                    value: "2",
                    "aria-label": "kein ausgebautes Dach",
                    "data-cy": "LoftConversionNO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.dachvariante]
                  ]),
                  _cache[40] || (_cache[40] = _createElementVNode("label", {
                    for: "dachNichtAusgebaut",
                    class: "radiolabelDachausbau"
                  }, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "flachdach",
                    name: "dachvariante",
                    class: "no-outline",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.dachvariante) = $event)),
                    type: "radio",
                    value: "1",
                    "aria-label": "Flachdach",
                    "data-cy": "FlatRoof"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.dachvariante]
                  ]),
                  _cache[41] || (_cache[41] = _createElementVNode("label", {
                    for: "flachdach",
                    class: "radiolabelDachausbau"
                  }, null, -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.dachvariante,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_Infotext, {
                    name: "dachVarianteInfo",
                    "css-klassen": "o-grid__cell--no-space",
                    text: "Als Vollgeschoss gelten alle zu Wohnzwecken ausgebauten Etagen. Ausgenommen sind Geschosse mit Schrägen (Dachausbau) sowie Keller."
                  })
                ]),
                _: 1,
                __: [39,40,41]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "anzahlVollgeschosseInfo"
              }, {
                default: _withCtx(() => _cache[42] || (_cache[42] = [
                  _createElementVNode("strong", null, "Anzahl Vollgeschosse", -1)
                ])),
                _: 1,
                __: [42]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "anzahlVollgeschosse",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.anzahlVollgeschosse) = $event)),
                    class: "c-form-control-select",
                    "data-cy": "NumberOfFloors",
                    "aria-label": "Anzahl der Vollgeschoss"
                  }, _cache[43] || (_cache[43] = [
                    _createElementVNode("option", {
                      selected: "",
                      value: "1"
                    }, "1", -1),
                    _createElementVNode("option", { value: "2" }, "2", -1),
                    _createElementVNode("option", { value: "3" }, "3", -1),
                    _createElementVNode("option", { value: "4" }, "4", -1),
                    _createElementVNode("option", { value: "5" }, "5", -1),
                    _createElementVNode("option", { value: "6" }, "6", -1),
                    _createElementVNode("option", { value: "7" }, "7", -1)
                  ]), 512), [
                    [
                      _vModelSelect,
                      _ctx.piniaStore.state.gebaeudedaten.anzahlVollgeschosse,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_infotext, {
                    name: "anzahlVollgeschosseInfo",
                    "css-klassen": "o-grid__cell--no-space",
                    text: "Als Vollgeschoss gelten alle zu Wohnzwecken ausgebauten Etagen.\n            Ausgenommen sind Dachgeschosse mit Schrägen sowie Keller."
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.istMehrfamilienhaus(_ctx.piniaStore.state) && _ctx.istFerienhaus(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[44] || (_cache[44] = [
                  _createElementVNode("strong", null, "Anzahl Wohneinheiten", -1)
                ])),
                _: 1,
                __: [44]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "anzahlWohneinheiten",
                    name: "anzahlWohneinheiten",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.anzahlWohnungen) = $event)),
                    class: "c-form-control-select",
                    "data-cy": "wohneinheiten",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Anzahl der Wohneinheiten"
                  }, _cache[45] || (_cache[45] = [
                    _createElementVNode("option", {
                      selected: "",
                      value: "-1"
                    }, "Bitte wählen", -1),
                    _createElementVNode("option", { value: "2" }, "2", -1),
                    _createElementVNode("option", { value: "3" }, "3", -1),
                    _createElementVNode("option", { value: "4" }, "4", -1),
                    _createElementVNode("option", { value: "5" }, "5", -1),
                    _createElementVNode("option", { value: "6" }, "6", -1),
                    _createElementVNode("option", { value: "7" }, "7", -1),
                    _createElementVNode("option", { value: "8" }, "8", -1),
                    _createElementVNode("option", { value: "9" }, "9", -1),
                    _createElementVNode("option", { value: "10" }, "10", -1)
                  ]), 512), [
                    [
                      _vModelSelect,
                      _ctx.piniaStore.state.gebaeudedaten.anzahlWohnungen,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.anzahlWohneinheiten,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "wohnflaecheVGVInfo"
              }, {
                default: _withCtx(() => _cache[46] || (_cache[46] = [
                  _createElementVNode("strong", null, "Wohnfläche", -1),
                  _createTextVNode(" in m"),
                  _createElementVNode("sup", null, "2", -1)
                ])),
                _: 1,
                __: [46]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "wohnflaecheVGV",
                    name: "wohnflaecheVGV",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vgv.wohnflaeche) = $event)),
                    class: "c-form-control__input",
                    min: _ctx.piniaStore.state.isMakler ? 1 : 15,
                    max: "5000",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Wohnfläche in Quadratmetern",
                    placeholder: "m²",
                    "data-fehlermeldung": 
            'Bitte geben Sie eine Fläche zwischen ' + (_ctx.piniaStore.state.isMakler ? 1 : 15) + ' und 5.000 m² ein.'
          ,
                    "data-cy": "AreaLiving"
                  }, null, 40, _hoisted_1), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.ferienhaus.vgv.wohnflaeche,
                      void 0,
                      {
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.wohnflaecheVGV
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, {
                breite: 8,
                offset: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_infotext, {
                    name: "wohnflaecheVGVInfo",
                    "css-klassen": "o-grid__cell--no-space",
                    text: "Die Wohnfläche ist die Grundfläche aller Räume des Gebäudes\n          einschließlich Hobbyräume. Nicht zu berücksichtigen sind Treppen,\n          Balkone, Loggien und Terrassen sowie Keller-, Speicher- und\n          Bodenräume, die nicht zu Wohn- oder Hobbyzwecken genutzt werden.<br />\n          Alternativ akzeptieren wir die Angabe der Gesamtfläche entsprechend\n          <ul style=\"padding-left: 0.9em;\">\n          <li>der Wohnflächenverordnung (WoFlV),</li>\n          <li>der Nutzfläche gemäß DIN 277,</li>\n          <li>\n            dem Miet- oder Kaufvertrag, sofern dieser den aktuellen\n            Ausbauzustand wiedergibt.\n          </li>\n          </ul>"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[47] || (_cache[47] = [
                  _createElementVNode("strong", null, "Keller", -1),
                  _createTextVNode(" vorhanden?")
                ])),
                _: 1,
                __: [47]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "kellerVorhandenNein",
                    name: "kellerVorhanden",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.kellerVorhanden) = $event)),
                    value: false,
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Nein, es ist kein Keller vorhanden",
                    "data-fehlermeldung": "Bitte wählen Sie die Art der Unterkellerung aus.",
                    "data-cy": "BasementNo"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.kellerVorhanden]
                  ]),
                  _cache[48] || (_cache[48] = _createElementVNode("label", {
                    for: "kellerVorhandenNein",
                    class: "radiolabel"
                  }, "Nein", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "kellerVorhandenJa",
                    name: "kellerVorhanden",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.kellerVorhanden) = $event)),
                    value: true,
                    "aria-label": "Ja, es ist ein Keller vorhanden",
                    "data-cy": "Basement"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.kellerVorhanden]
                  ]),
                  _cache[49] || (_cache[49] = _createElementVNode("label", {
                    for: "kellerVorhandenJa",
                    class: "radiolabel"
                  }, "Ja", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.kellerVorhanden,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1,
                __: [48,49]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.gebaeudedaten.kellerVorhanden === true && !_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 6 }, {
            default: _withCtx(() => [
              (_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === false)
                ? (_openBlock(), _createBlock(_component_titel_zelle, { key: 0 }, {
                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                      _createElementVNode("strong", null, "Kellerfläche", -1),
                      _createTextVNode(" bei Wohn- oder Hobbynutzung in m"),
                      _createElementVNode("sup", null, "2", -1)
                    ])),
                    _: 1,
                    __: [50]
                  }))
                : (_openBlock(), _createBlock(_component_titel_zelle, { key: 1 }, {
                    default: _withCtx(() => _cache[51] || (_cache[51] = [
                      _createElementVNode("strong", null, "Kellerfläche", -1),
                      _createTextVNode(" bei Wohn- und Hobbynutzung in m"),
                      _createElementVNode("sup", null, "2", -1)
                    ])),
                    _: 1,
                    __: [51]
                  })),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "wohnflaecheKeller",
                    name: "wohnflaecheKeller",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.wohnflaecheKeller) = $event)),
                    class: "c-form-control__input",
                    placeholder: "m²",
                    min: "0",
                    max: _ctx.piniaStore.state.ferienhaus.vgv.wohnflaeche ? _ctx.piniaStore.state.ferienhaus.vgv.wohnflaeche : 999,
                    required: _ctx.piniaStore.state.gebaeudedaten.kellerVorhanden === true,
                    "aria-required": _ctx.piniaStore.state.gebaeudedaten.kellerVorhanden === true,
                    "aria-label": "Kellerfläche bei Wohn- und Hobbynutzung in Quadratmetern",
                    "data-fehlermeldung": 
            'Bitte geben Sie eine Kellerfläche zwischen 0 und ' +
            (_ctx.piniaStore.state.ferienhaus.vgv.wohnflaeche ? _ctx.piniaStore.state.ferienhaus.vgv.wohnflaeche : 999) +
            ' m² ein.'
          ,
                    "data-cy": "AreaLivingBasement"
                  }, null, 40, _hoisted_2), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.wohnflaecheKeller,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.wohnflaecheKeller
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 7 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[52] || (_cache[52] = [
                  _createElementVNode("strong", null, "Garagen oder Carports", -1),
                  _createTextVNode(" vorhanden?")
                ])),
                _: 1,
                __: [52]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "parkplaetzeVorhandenNein",
                    name: "parkplaetzeVorhanden",
                    value: false,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden) = $event)),
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Nein, es sind keine Parkplätze vorhanden",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                    "data-cy": "CarParkNo"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden]
                  ]),
                  _cache[53] || (_cache[53] = _createElementVNode("label", {
                    for: "parkplaetzeVorhandenNein",
                    class: "radiolabel"
                  }, "Nein", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "parkplaetzeVorhandenJa",
                    value: true,
                    name: "parkplaetzeVorhanden",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden) = $event)),
                    "aria-label": "Jan, es sind Parkplätze vorhanden",
                    "data-cy": "CarPark"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden]
                  ]),
                  _cache[54] || (_cache[54] = _createElementVNode("label", {
                    for: "parkplaetzeVorhandenJa",
                    class: "radiolabel"
                  }, "Ja", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.parkplaetzeVorhanden,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1,
                __: [53,54]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden === true && !_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "garagenInfo"
              }, {
                default: _withCtx(() => [
                  _cache[55] || (_cache[55] = _createTextVNode(" Anzahl der Stellplätze in ")),
                  _cache[56] || (_cache[56] = _createElementVNode("strong", null, "Garagen", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.piniaStore.state.isMakler === true && _ctx.isEfhZfh ? "außerhalb des Hauptgebäudes" : ""), 1)
                ]),
                _: 1,
                __: [55,56]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "anzahlGaragen",
                    name: "anzahlGaragen",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.anzahlGaragen) = $event)),
                    class: "c-form-control__input",
                    placeholder: "0-99",
                    min: "0",
                    max: "99",
                    required: _ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden,
                    "aria-required": _ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden,
                    "aria-label": "Anzahl der Stellplätze in Garagen",
                    "data-fehlermeldung": "Bitte geben Sie die Anzahl der Stellplätze zwischen 0 und 99 ein.",
                    "data-cy": "GarageSpace"
                  }, null, 40, _hoisted_3), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.anzahlGaragen,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.anzahlGaragen
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_infotext, {
                    name: "garagenInfo",
                    "css-klassen": "o-grid__cell--no-space",
                    text: " Zu Garagen zählen wir:<br />- freistehende Garagen<br />\n            - angebaute Garagen<br />- Tiefgaragen"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden === true && !_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 9 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[57] || (_cache[57] = [
                  _createTextVNode(" Anzahl der Stellplätze in "),
                  _createElementVNode("strong", null, "Carports", -1)
                ])),
                _: 1,
                __: [57]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "anzahlCarports",
                    name: "anzahlCarports",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.anzahlCarports) = $event)),
                    class: "c-form-control__input",
                    placeholder: "0-99",
                    min: "0",
                    max: "99",
                    required: _ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden,
                    "aria-required": _ctx.piniaStore.state.gebaeudedaten.parkplaetzeVorhanden,
                    "aria-label": "Anzahl der Stellplätze in Carports",
                    "data-fehlermeldung": "Bitte geben Sie die Anzahl der Stellplätze zwischen 0 und 99 ein.",
                    "data-cy": "CarportSpace"
                  }, null, 40, _hoisted_4), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.anzahlCarports,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.anzahlCarports
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "photovoltaikInfo"
              }, {
                default: _withCtx(() => _cache[58] || (_cache[58] = [
                  _createElementVNode("strong", null, "Photovoltaikanlage", -1),
                  _createTextVNode(" auf dem Gebäude? ")
                ])),
                _: 1,
                __: [58]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "photovoltaikNein",
                    name: "photovoltaikVorhanden",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.photovoltaikVorhanden) = $event)),
                    value: false,
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Nein, es befindet sich keine Photovoltaikanlage auf dem Gebäude",
                    "data-fehlermeldung": "Bitte wählen Sie aus, ob eine PV-Anlage existiert.",
                    "data-cy": "PhotovoltaicNo"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.photovoltaikVorhanden]
                  ]),
                  _cache[59] || (_cache[59] = _createElementVNode("label", {
                    for: "photovoltaikNein",
                    class: "radiolabel"
                  }, "Nein", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "photovoltaikJa",
                    value: true,
                    name: "photovoltaikVorhanden",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.photovoltaikVorhanden) = $event)),
                    "aria-label": "Ja, es befindet sich eine Photovoltaikanlage auf dem Gebäude",
                    "data-cy": "Photovoltaic"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.photovoltaikVorhanden]
                  ]),
                  _cache[60] || (_cache[60] = _createElementVNode("label", {
                    for: "photovoltaikJa",
                    class: "radiolabel"
                  }, "Ja", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.photovoltaikVorhanden,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_infotext, {
                    name: "photovoltaikInfo",
                    "css-klassen": "o-grid__cell--no-space",
                    text: _ctx.photovoltaikInfoText
                  }, null, 8, ["text"])
                ]),
                _: 1,
                __: [59,60]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.pvDetailfragenAnzeigenUndPruefen)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 11 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[61] || (_cache[61] = [
                  _createElementVNode("strong", null, "Baujahr", -1),
                  _createTextVNode(" der Photovoltaikanlage")
                ])),
                _: 1,
                __: [61]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "photovoltaikBaujahr",
                    name: "photovoltaikBaujahr",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.photovoltaikBaujahr) = $event)),
                    class: "c-form-control__input",
                    placeholder: "JJJJ",
                    min: _ctx.baujahrMin,
                    max: _ctx.baujahrMax,
                    required: _ctx.pvDetailfragenAnzeigenUndPruefen,
                    "aria-required": _ctx.pvDetailfragenAnzeigenUndPruefen,
                    "aria-label": "Baujahr der Photovoltaikanlage",
                    "data-fehlermeldung": _ctx.baujahrFehlerText,
                    "data-cy": "PhotovoltaicYear"
                  }, null, 40, _hoisted_5), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.photovoltaikBaujahr,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  (_ctx.zeigeHinweisPvAnlageBaujahr)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[62] || (_cache[62] = [
                        _createTextVNode(" Der Einschluss einer zusätzlichen Absicherung der Photovoltaikanlage ist aufgrund der fehlenden Voraussetzungen des Alters der Anlage nicht möglich."),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" Hinweis: Gegen Schäden durch Feuer, Sturm und Hagel ist die PV-Anlage generell mitversichert. ")
                      ])))
                    : _createCommentVNode("", true),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.photovoltaikBaujahr
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.pvDetailfragenAnzeigenUndPruefen)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[63] || (_cache[63] = [
                  _createElementVNode("strong", null, "Leistung", -1),
                  _createTextVNode(" der Photovoltaikanlage in kWp (Spitzenleistung)")
                ])),
                _: 1,
                __: [63]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "photovoltaikLeistung",
                    name: "photovoltaikLeistung",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.photovoltaikLeistung) = $event)),
                    onKeydown: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    class: "c-form-control__input",
                    placeholder: "kWp",
                    min: "1",
                    max: "99",
                    required: _ctx.pvDetailfragenAnzeigenUndPruefen,
                    "aria-required": _ctx.pvDetailfragenAnzeigenUndPruefen,
                    "aria-label": "Leistung der Photovoltaikanlage in kWp (Spitzenleistung)",
                    "data-fehlermeldung": "Bitte geben Sie die Leistung in ganzen kWp an (1-99).",
                    "data-cy": "PhotovoltaicPower"
                  }, null, 40, _hoisted_7), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.photovoltaikLeistung,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  (_ctx.zeigeHinweisPvAnlageLeistung)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[64] || (_cache[64] = [
                        _createTextVNode(" Der Einschluss einer zusätzlichen Absicherung der Photovoltaikanlage ist aufgrund der fehlenden Voraussetzungen der Leistung der Anlage nicht möglich."),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" Hinweis: Gegen Schäden durch Feuer, Sturm und Hagel ist die PV-Anlage generell mitversichert. ")
                      ])))
                    : _createCommentVNode("", true),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.photovoltaikLeistung
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_ueberschrift, { key: 13 }, {
            default: _withCtx(() => _cache[65] || (_cache[65] = [
              _createTextVNode("Angaben zur Nutzung")
            ])),
            _: 1,
            __: [65]
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 14 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[66] || (_cache[66] = [
                  _createTextVNode("Nutzungsart des Gebäudes?")
                ])),
                _: 1,
                __: [66]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vgv.nutzungsart) = $event)),
                    type: "radio",
                    id: "eigennutzungVGV",
                    name: "nutzungsartVGV",
                    value: 1,
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Überwiegend Eigennutzung",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                    "data-cy": "eigennutzungVGV"
                  }, null, 512), [
                    [
                      _vModelRadio,
                      _ctx.piniaStore.state.ferienhaus.vgv.nutzungsart,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _cache[67] || (_cache[67] = _createElementVNode("label", {
                    for: "eigennutzungVGV",
                    class: "radiolabel"
                  }, "Überwiegend Eigennutzung", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vgv.nutzungsart) = $event)),
                    type: "radio",
                    id: "fremdnutzungVGV",
                    name: "nutzungsartVGV",
                    value: 2,
                    "aria-label": "Überwiegend Fremdnutzung",
                    "data-cy": "fremdnutzungVGV"
                  }, null, 512), [
                    [
                      _vModelRadio,
                      _ctx.piniaStore.state.ferienhaus.vgv.nutzungsart,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _cache[68] || (_cache[68] = _createElementVNode("label", {
                    for: "fremdnutzungVGV",
                    class: "radiolabel"
                  }, "Überwiegend Fremdnutzung", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.nutzungsartVGV,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1,
                __: [67,68]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 15 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[69] || (_cache[69] = [
                  _createElementVNode("strong", null, "Wieviele Tage im Jahr bewohnt/vermietet?", -1)
                ])),
                _: 1,
                __: [69]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "unbewohnteTageVGV",
                    name: "unbewohnteTageVGV",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vgv.tageUnbewohnt) = $event)),
                    class: "c-form-control-select",
                    "data-cy": "unbewohnteTageVGV",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Wieviele Tage im Jahr bewohnt/vermietet?"
                  }, _cache[70] || (_cache[70] = [
                    _createElementVNode("option", {
                      selected: "",
                      value: "-1"
                    }, "Bitte wählen", -1),
                    _createElementVNode("option", { value: "3" }, "Weniger als 95 Tage/Jahr", -1),
                    _createElementVNode("option", { value: "2" }, "95-180 Tage/Jahr", -1),
                    _createElementVNode("option", { value: "1" }, "Mehr als 180 Tage/Jahr", -1)
                  ]), 512), [
                    [
                      _vModelSelect,
                      _ctx.piniaStore.state.ferienhaus.vgv.tageUnbewohnt,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.unbewohnteTageVGV,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        (!_ctx.istNurVGV(_ctx.piniaStore.state) && _ctx.istMehrfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istVGVundVHV(_ctx.piniaStore.state) && _ctx.istEinfamilienhaus(_ctx.piniaStore.state))
      )
        ? (_openBlock(), _createBlock(_component_ueberschrift, { key: 16 }, {
            default: _withCtx(() => _cache[71] || (_cache[71] = [
              _createTextVNode("Angaben zur Hausratversicherung ")
            ])),
            _: 1,
            __: [71]
          }))
        : _createCommentVNode("", true),
      (
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istEinfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istFerienwohnung(_ctx.piniaStore.state))
      )
        ? (_openBlock(), _createBlock(_component_ueberschrift, { key: 17 }, {
            default: _withCtx(() => _cache[72] || (_cache[72] = [
              _createTextVNode("Angaben zur Immobilie ")
            ])),
            _: 1,
            __: [72]
          }))
        : _createCommentVNode("", true),
      (
        (!_ctx.istNurVGV(_ctx.piniaStore.state) && _ctx.istMehrfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istEinfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istFerienwohnung(_ctx.piniaStore.state))
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 18 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[73] || (_cache[73] = [
                  _createTextVNode("Nutzungsart der zu versichernden Wohnung?")
                ])),
                _: 1,
                __: [73]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.nutzungsart) = $event)),
                    type: "radio",
                    id: "eigennutzungVHV",
                    name: "nutzungsartVHV",
                    value: 1,
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Überwiegend Eigennutzung",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                    "data-cy": "eigennutzungVHV"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.ferienhaus.vhv.nutzungsart]
                  ]),
                  _cache[74] || (_cache[74] = _createElementVNode("label", {
                    for: "eigennutzungVHV",
                    class: "radiolabel"
                  }, "Überwiegend Eigennutzung", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.nutzungsart) = $event)),
                    type: "radio",
                    id: "fremdnutzungVHV",
                    name: "nutzungsartVHV",
                    value: 2,
                    "aria-label": "Überwiegend Fremdnutzung",
                    "data-cy": "fremdnutzungVHV"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.ferienhaus.vhv.nutzungsart]
                  ]),
                  _cache[75] || (_cache[75] = _createElementVNode("label", {
                    for: "fremdnutzungVHV",
                    class: "radiolabel"
                  }, "Überwiegend Fremdnutzung", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.nutzungsartVHV,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1,
                __: [74,75]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        (!_ctx.istNurVGV(_ctx.piniaStore.state) && _ctx.istMehrfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istEinfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istFerienwohnung(_ctx.piniaStore.state))
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 19 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[76] || (_cache[76] = [
                  _createElementVNode("strong", null, "Wieviele Tage im Jahr bewohnt/vermietet?", -1)
                ])),
                _: 1,
                __: [76]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "unbewohnteTageVHV",
                    name: "unbewohnteTageVHV",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.tageUnbewohnt) = $event)),
                    class: "c-form-control-select",
                    "data-cy": "unbewohnteTageVHV",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Wieviele Tage im Jahr bewohnt/vermietet?"
                  }, _cache[77] || (_cache[77] = [
                    _createElementVNode("option", {
                      selected: "",
                      value: "-1"
                    }, "Bitte wählen", -1),
                    _createElementVNode("option", { value: "3" }, "Weniger als 95 Tage/Jahr", -1),
                    _createElementVNode("option", { value: "2" }, "95-180 Tage/Jahr", -1),
                    _createElementVNode("option", { value: "1" }, "Mehr als 180 Tage/Jahr", -1)
                  ]), 512), [
                    [
                      _vModelSelect,
                      _ctx.piniaStore.state.ferienhaus.vhv.tageUnbewohnt,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.unbewohnteTageVHV,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        (!_ctx.istNurVGV(_ctx.piniaStore.state) && _ctx.istMehrfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istEinfamilienhaus(_ctx.piniaStore.state)) ||
        (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istFerienwohnung(_ctx.piniaStore.state))
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[78] || (_cache[78] = [
                  _createElementVNode("strong", null, "Wohnfläche", -1),
                  _createTextVNode(" in m"),
                  _createElementVNode("sup", null, "2", -1)
                ])),
                _: 1,
                __: [78]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "wohnflaecheVHV",
                    name: "wohnflaecheVHV",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.wohnflaeche) = $event)),
                    class: "c-form-control__input",
                    min: "1",
                    "data-fehlermeldung": _ctx.hausratWohnflaecheFehlermeldung,
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Wohnfläche in Quadratmetern",
                    placeholder: "m²",
                    max: _ctx.maxHausratWohnflaeche,
                    "data-cy": "AreaLiving2"
                  }, null, 40, _hoisted_9), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.ferienhaus.vhv.wohnflaeche,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.wohnflaecheVHV
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.istNurVGV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 21 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "versicherungssummeInfo"
              }, {
                default: _withCtx(() => _cache[79] || (_cache[79] = [
                  _createTextVNode(" Höhe der Versicherungssumme in € ")
                ])),
                _: 1,
                __: [79]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "versicherungssumme",
                    name: "versicherungssumme",
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.versicherungssumme) = $event)),
                    onBlur: _cache[34] || (_cache[34] = ($event: any) => (_ctx.manuellGesetzt = true)),
                    class: "c-form-control__input",
                    min: "1000",
                    max: "150000",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Höhe der Versicherungssumme in Euro",
                    "data-fehlermeldung": "Bitte geben Sie eine Versicherungssumme in vollen Euro (zwischen 1000 und 150000 EUR) ohne Punkt und Komma ein.",
                    "data-cy": "versicherungssumme"
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.versicherungssumme,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.versicherungssumme
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, {
                breite: 8,
                offset: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_infotext, {
                    name: "versicherungssummeInfo",
                    "css-klassen": "o-grid__cell--no-space",
                    text: _ctx.versicherungssummeInfoText,
                    schliesstBeiKlickAufText: false
                  }, null, 8, ["text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.istNurVHV(_ctx.piniaStore.state) && _ctx.istFerienwohnung(_ctx.piniaStore.state))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 22 }, [
            _createVNode(_component_ueberschrift, null, {
              default: _withCtx(() => _cache[80] || (_cache[80] = [
                _createTextVNode("Geburtsdatum")
              ])),
              _: 1,
              __: [80]
            }),
            _createVNode(_component_zeile, null, {
              default: _withCtx(() => [
                _createVNode(_component_titel_zelle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(!_ctx.piniaStore.state.isMakler ? "Ihr " : "") + "Geburtsdatum", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_zelle, { breite: 6 }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      style: {"width":"50%"},
                      type: "date",
                      id: "geburtsdatum",
                      name: "geburtsdatum",
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum) = $event)),
                      class: "c-form-control__input",
                      placeholder: "TT.MM.JJJJ",
                      title: "Geburtsdatum im Format TT.MM.JJJJ",
                      required: "",
                      "aria-required": "true",
                      "aria-label": "Geburtsdatum",
                      "data-checkalter18bis100": "true",
                      "data-cy": "versicherungsnehmerGeburtstag"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum,
                        void 0,
                        {
                          lazy: true,
                          trim: true
                        }
                      ]
                    ]),
                    _createVNode(_component_validierungs_fehler, {
                      "fehler-text": _ctx.fehler.geburtsdatum
                    }, null, 8, ["fehler-text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 5,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                "data-cy": "submitZumVergleich"
              }, " Weiter zur Tarifauswahl ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}